export default "__VITE_ASSET__746a494a__"